import { Col, Form, Input, Radio, Row, Space } from "antd";
import styles from "./ApprovalForm.module.less";
import type { FlowSkipType } from "@/constants";
import { PrimaryButton } from "../ui/buttons/PrimaryButton";
import { ReactNode } from "react";

export type ApprovalFormFields = {
  skipType: FlowSkipType;
  message: string;
};

type Props = {
  loading?: boolean;
  onApprovalSubmit: (values: ApprovalFormFields) => void;
  leftExtend?: ReactNode;
};

export function ApprovalForm({ onApprovalSubmit, loading, leftExtend }: Props) {
  const [form] = Form.useForm<ApprovalFormFields>();

  const onSubmit = async () => {
    const values = await form.validateFields();

    onApprovalSubmit(values);
  };
  return (
    <div className={styles.approvalForm}>
      <Form form={form}>
        <Row>
          <Col span={24} style={{ textAlign: "left" }}>
            <Form.Item<ApprovalFormFields>
              label="审批意见"
              name="skipType"
              rules={[{ required: true, message: "请选择审批意见" }]}
              className={styles.marginBottomResize}
            >
              <Radio.Group
                style={{
                  justifyContent: "left",
                }}
                options={[
                  { value: "PASS", label: "通过" },
                  { value: "REJECT", label: "驳回" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item<ApprovalFormFields>
              label="意见说明"
              name="message"
              className={styles.marginBottomResize}
            >
              <Input.TextArea placeholder="请输入" maxLength={300} />
            </Form.Item>
          </Col>
        </Row>

        <div className={styles.footer}>
          <Space>
            {leftExtend}
            <PrimaryButton loading={loading} onClick={onSubmit}>
              提交
            </PrimaryButton>
          </Space>
        </div>
      </Form>
    </div>
  );
}
